import { render, staticRenderFns } from "./Warning.vue?vue&type=template&id=ab03583c"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data0/web/xyadmin.98du.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab03583c')) {
      api.createRecord('ab03583c', component.options)
    } else {
      api.reload('ab03583c', component.options)
    }
    module.hot.accept("./Warning.vue?vue&type=template&id=ab03583c", function () {
      api.rerender('ab03583c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/example/components/Warning.vue"
export default component.exports